// App.js
import React, { useState } from 'react';
import { BrowserRouter as Router, Route, Routes, Navigate } from 'react-router-dom';
import Login from './components/Login';
import Dashboard from './components/Dashboard';
import Home from './pages/Home';
import About from './pages/About';
import Contact from './pages/Contact';
import Services from './pages/Services';
import Users from './components/Users';

function App() {
  const [token, setToken] = useState(null);

  return (
    <Router>
          <Routes>

        <Route
          path="/dashboard"
          element={token !== null ? <Dashboard token={token}/> : <Navigate to="/login" />}
           />

              /* Website routes */
              <Route path="/" element={<Home />} />
              <Route path="/home" element={<Home />} />
              <Route path="/about" element={<About />} />
              <Route path="/contact" element={<Contact />} />
              <Route path="/services" element={<Services />} />
              <Route path="/users" element={<Users />} />

              /* Admin routes */
              <Route path="/admin" element={<Login setToken={setToken} />} />
          </Routes>
    </Router>
  );
}

export default App;
